export const isUKAndIreland = (countryCode: string) => {
  return (
    countryCode.toLowerCase() === "gb" || countryCode.toLowerCase() === "ie"
  );
};
